import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Spin } from '@/ui/compat/antd';
import { Route, Routes } from 'react-router-dom';
import useAmicale from '../hooks/useAmicale';
import { AMICALE_STATUS } from '../context/AmicaleContext';
import { amicaleRoutesConfig } from '../routes/amicaleRoutesConfig';

const FullPageLoader = ({ label }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 16,
      height: '100vh',
      background:
        'linear-gradient(180deg, var(--gray-200) 0%, rgba(30, 58, 138, 0.06) 100%)',
    }}
  >
    <Spin size="large" />
    {label ? (
      <span
        style={{
          fontSize: 'var(--font-size-base)',
          color: 'var(--color-primary-800)',
          fontWeight: 'var(--font-weight-medium)',
          letterSpacing: 0.2,
        }}
      >
        {label}
      </span>
    ) : null}
  </div>
);

const renderRoute = (route, index) => {
  if (route.children?.length) {
    return (
      <Route key={index} path={route.path} element={route.element}>
        {route.children.map((child, childIndex) =>
          renderRoute(child, `${index}-${childIndex}`)
        )}
      </Route>
    );
  }

  if (route.index) {
    return <Route key={index} index element={route.element} />;
  }

  return <Route key={index} path={route.path} element={route.element} />;
};

const AmicaleGate = ({ children }) => {
  const { t } = useTranslation();
  const { status, isAmical, client } = useAmicale();

  useEffect(() => {
    if (!isAmical || !client) return;

    if (client.name) {
      document.title = import.meta.env.VITE_GSA_NAME + " - " + client.name;
    }

    const faviconUrl = import.meta.env.VITE_BACKEND_URL + client.logoUrl;
    if (faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
      }
      link.href = faviconUrl;
    }
  }, [isAmical, client]);

  if (status === AMICALE_STATUS.LOADING || status === AMICALE_STATUS.IDLE) {
    return <FullPageLoader label={t('amicales.gate.connecting')} />;
  }

  if (!isAmical) {
    return children;
  }

  return <Routes>{amicaleRoutesConfig.map(renderRoute)}</Routes>;
};

export default AmicaleGate;
